import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Modal from './../../Global/Modals/Modal';
import Button from '@material-ui/core/Button';
import ButtonStyles from '../../../styles/button';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import CommentHeader from './CommentHeader';
import _get from 'lodash/get';
import CommentsInputStyles from './CommentsInput.module.css';
import { MentionsInput, Mention } from 'react-mentions';
import combineStyles from './../../../utils/combineStyles';
import ProgressButton from '../../Global/Buttons/Progress';
import classnames from 'classnames';

const styles = theme => ({
  commentContainer: { paddingTop: theme.spacing.unit * 2.5 },
  commentWrapper: {
    border: '1px solid rgba(12,31,44,0.12)',
    borderRadius: '4px',
    padding: theme.spacing.unit,
    display: 'flex',
    alignContent: 'flex-start'
  }
});
export class EditCommentModal extends PureComponent {
  static propTypes = {
    options: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCommentUpdate: PropTypes.func.isRequired
  };
  state = { content: '', isSubmitting: false };

  componentDidUpdate(prevProps) {
    const oldContent = _get(prevProps, 'options.comment.content', '');
    const content = _get(this.props, 'options.comment.content', '');

    if (oldContent !== content) {
      this.setState({ content });
    }
  }
  handleChange = ({ target: { value } }) => {
    this.setState({ content: value });
  };
  _handleCommentSave = async () => {
    const { content } = this.state;
    const {
      options: {
        comment: { id }
      },
      onCommentUpdate
    } = this.props;
    this.setState({ isSubmitting: true });
    const isSuccessful = await onCommentUpdate(id, content);
    if (isSuccessful) {
      this.setState({ isSubmitting: false });
    }
  };
  render() {
    const { open, options = {}, onClose, classes, t } = this.props;
    const {
      comment = {},
      users = [],
      isAdmin = false,
      editable = false
    } = options;
    const { content, isSubmitting } = this.state;
    const { changedUtc = '', createdByUser = {} } = comment;

    return (
      <Modal
        open={open}
        body={
          <Fragment>
            <CommentHeader
              inEditMode={true}
              firstName={_get(createdByUser, 'firstName', '')}
              lastName={_get(createdByUser, 'lastName', '')}
              changedUtc={changedUtc}
              comment={comment}
              users={users}
              editable={editable}
              deletable={isAdmin}
              isAdmin={isAdmin}
            />
            <div className={classes.commentContainer}>
              <div className={classes.commentWrapper}>
                <MentionsInput
                  value={content}
                  onChange={this.handleChange}
                  placeholder={`${t('Leave a comment')}...`}
                  classNames={CommentsInputStyles}
                >
                  <Mention trigger="@" data={users} />
                </MentionsInput>
              </div>
            </div>
          </Fragment>
        }
        footer={
          <Fragment>
            <Button
              className={classes.button}
              onClick={onClose}
              color={'primary'}
              classes={{ label: classes.buttonLabel }}
            >
              {t('Cancel')}
            </Button>
            <ProgressButton
              color="primary"
              className={classnames(classes.button)}
              classes={{
                disabled: classes.buttonDisabled,
                label: classnames(classes.buttonLabel)
              }}
              onClick={this._handleCommentSave}
              isSubmitting={isSubmitting}
            >
              {t('Update')}
            </ProgressButton>
          </Fragment>
        }
      />
    );
  }
}
const translatedEditCommentModal = withNamespaces()(EditCommentModal);
export default withStyles(combineStyles(ButtonStyles, styles))(
  translatedEditCommentModal
);
